<template>
  <div class="related-field-set-wrapper">
    <b-row
      v-if="sourceField"
      class="source-field"
    >
      <b-col class="column">
        <label>{{sourceField.label}}</label>
        <template v-if="sourceField && sourceField.type && sourceField.type === 'text'">
          <b-form-input
            type="text"
            :id="sourceField.key"
            :disabled="sourceField.disabled"
            :placeholder="sourceField.placeholder ? sourceField.placeholder : ''"
            :value="getSourceFieldValue()"
            :state="getState(sourceField.validationKey)"
          />
          <b-form-invalid-feedback>
            {{ getInvalidFeedback(sourceField.validationKey) }}
          </b-form-invalid-feedback>
        </template>
        <b-button
          v-if="sourceField.showActionButton"
          class="action-button"
          variant="primary"
          @click="sourceFieldSelectModalOpen"
        >
          {{ sourceFieldButtonText }}
        </b-button>
      </b-col>
    </b-row>
    <b-row
      v-if="relatedField"
      class="related-field"
    >
      <b-col class="column">
        <label>{{relatedField.label}}</label>
        <template v-if="relatedField.type && relatedField.type === 'text'">
          <b-form-textarea
            :id="relatedField.key"
            :disabled="relatedField.disabled"
            :placeholder="relatedField.placeholder ? relatedField.placeholder : ''"
            :value="getRelatedFieldValue()"
            :state="getState(relatedField.validationKey)"
          />
          <b-form-invalid-feedback>
            {{ getInvalidFeedback(relatedField.validationKey) }}
          </b-form-invalid-feedback>
        </template>
        <b-button
          v-if="
            relatedField.showActionButton && formData[fieldSetKey] && formData[fieldSetKey]['sourceField']
              && formData[fieldSetKey]['sourceField'].length
          "
          class="action-button"
          variant="primary"
          @click="relatedFieldSelectModalOpen"
        >
          {{ relatedFieldButtonText }}
        </b-button>
      </b-col>
    </b-row>
    <b-modal
      v-model="sourceFieldModalVisible"
      :title="sourceFieldModalTitle"
      size="lg"
      @hide="onSourceFieldModalHide"
    >
      <state-table
        :selectable="true"
        :select-mode="tableSelectMode.single"
        :items-load-method-name="sourceField.modalSettings.tableSettings.itemsLoadMethodName"
        :items-getter-name="sourceField.modalSettings.tableSettings.itemsGetterName"
        :items-count-getter-name="sourceField.modalSettings.tableSettings.itemsCountGetterName"
        :ref-name="sourceField.modalSettings.tableSettings.refName"
        :fields="sourceField.modalSettings.tableSettings.fields"
        :empty-text="sourceField.modalSettings.tableSettings.emptyText"
        :selected-rows="sourceFieldModalTableItemsSelected"
        @items-selected="onSourceFieldModalTableItemsSelected"
      />
      <template #modal-footer>
        <b-button variant="outline-danger" @click="sourceFieldModalCancel">Отменить</b-button>
        <b-button variant="success" @click="sourceFieldModalApply">Применить</b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="relatedFieldModalVisible"
      :title="relatedFieldModalTitle"
      size="xl"
      @hide="onRelatedFieldModalHide"
    >
      <state-table
        :selectable="true"
        :select-mode="relatedField.modalSettings.tableSettings.selectMode"
        :items-load-method-name="relatedField.modalSettings.tableSettings.itemsLoadMethodName"
        :items-getter-name="relatedField.modalSettings.tableSettings.itemsGetterName"
        :items-count-getter-name="relatedField.modalSettings.tableSettings.itemsCountGetterName"
        :ref-name="relatedField.modalSettings.tableSettings.refName"
        :fields="relatedField.modalSettings.tableSettings.fields"
        :empty-text="relatedField.modalSettings.tableSettings.emptyText"
        :items-load-method-resource-id="getSourceFieldResourceId()"
        :selected-rows="relatedFieldModalTableItemsSelected"
        @items-selected="onRelatedFieldModalTableItemsSelected"
      />
      <template #modal-footer>
        <b-button variant="outline-danger" @click="relatedFieldModalCancel">Отменить</b-button>
        <b-button variant="success" @click="relatedFieldModalApply">Применить</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {
  BFormInput, BFormSelect, BCol, BRow, BIconPlusCircleFill, BIconTrashFill, BIconXCircleFill, BFormSelectOption,
  BButton, BModal, BFormTextarea, BFormInvalidFeedback
} from 'bootstrap-vue'
import StateTable from '@/views/components/state-table/StateTable.vue'
import StateTableParams from '@/views/components/state-table/StateTableParams'
export default {
  name: 'RelatedFieldSet',
  components: {
    BFormInput, BFormSelect, BCol, BRow, BIconPlusCircleFill, BIconTrashFill, BIconXCircleFill, BFormSelectOption,
    BButton, BModal, StateTable, StateTableParams, BFormTextarea, BFormInvalidFeedback
  },
  emits: ['source-field-changed', 'related-field-changed'],
  props: {
    fieldSetKey: {
      type: String,
      required: true
    },
    sourceField: {
      type: Object,
      required: true
    },
    relatedField: {
      type: Object,
      required: true
    },
    notValidFields: {
      type: Object,
      default: function () {
        return null
      }
    },
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      addFieldSetButtonTitle: 'Добавить набор полей',
      removeFieldSetButtonTitle: 'Удалить набор полей',
      fieldsSetRows: [],
      defaultBColMdSize: 4,
      sourceFieldModalTitle: null,
      relatedFieldModalTitle: null,
      relatedFieldModalVisible: false,
      sourceFieldModalVisible: false,
      defaultModalTitle: 'Выберите',
      tableSelectMode: StateTableParams.stateTableSelectMode,
      sourceFieldModalTableItemsSelected: [],
      relatedFieldModalTableItemsSelected: [],
      sourceFieldButtonText: 'Выбрать',
      relatedFieldButtonText: 'Выбрать',
    }
  },
  created() {
    if (this.fieldSetKey && this.formData[this.fieldSetKey]) {
      if (this.formData[this.fieldSetKey]['sourceField'] && this.formData[this.fieldSetKey]['sourceField'].length) {
        this.sourceFieldModalTableItemsSelected = this.formData[this.fieldSetKey]['sourceField']
        this.sourceFieldButtonText = 'Изменить'
      }
      if (this.formData[this.fieldSetKey]['relatedField'] && this.formData[this.fieldSetKey]['relatedField'].length) {
        this.relatedFieldModalTableItemsSelected = this.formData[this.fieldSetKey]['relatedField']
        this.relatedFieldButtonText = 'Изменить'
      }
    }
  },
  methods: {
    getState(fieldName) {
      return !this.notValidFields || !this.notValidFields.hasOwnProperty(fieldName)
        ? null : false;
    },
    getInvalidFeedback(fieldName) {
      return this.notValidFields && this.notValidFields.hasOwnProperty(fieldName)
        ? this.notValidFields[fieldName] : null;
    },
    sourceFieldSelectModalOpen() {
      this.sourceFieldModalTitle = this.sourceField.placeholder ? this.sourceField.placeholder : this.defaultModalTitle
      this.sourceFieldModalShow()
    },
    sourceFieldModalCancel() {
      if (
        this.formData[this.fieldSetKey] && this.formData[this.fieldSetKey]['sourceField']
        && this.formData[this.fieldSetKey]['sourceField'].length
        && !this.sourceFieldModalTableItemsSelected.length
      ) {
        this.sourceFieldModalTableItemsSelected = this.formData[this.fieldSetKey]['sourceField']
      }
      this.sourceFieldModalHide()
    },
    sourceFieldModalApply() {
      this.sourceFieldButtonText = this.sourceFieldModalTableItemsSelected.length ? 'Изменить' : 'Выбрать'
      this.$emit('source-field-changed', this.sourceFieldModalTableItemsSelected)

      this.relatedFieldModalTableItemsSelected = []
      this.formData[this.fieldSetKey]['relatedField'] = null
      this.relatedFieldButtonText = 'Выбрать'
      this.$emit('related-field-changed', this.relatedFieldModalTableItemsSelected)

      this.sourceFieldModalHide()
    },
    sourceFieldModalShow() {
      this.sourceFieldModalVisible = true
    },
    sourceFieldModalHide() {
      this.sourceFieldModalVisible = false
    },
    onSourceFieldModalHide() {
      this.sourceFieldModalTitle = null
    },
    onSourceFieldModalTableItemsSelected(items) {
      this.sourceFieldModalTableItemsSelected = items
    },
    getSourceFieldValue() {
      if (
        this.formData[this.fieldSetKey]
        && this.formData[this.fieldSetKey]['sourceField']
        && this.formData[this.fieldSetKey]['sourceField'][0]
        && this.formData[this.fieldSetKey]['sourceField'][0][this.sourceField.key]
      ) {
        return this.formData[this.fieldSetKey]['sourceField'][0][this.sourceField.key]
      }
      return null
    },
    relatedFieldSelectModalOpen() {
      this.relatedFieldModalTitle = this.relatedField.placeholder ?
        this.relatedField.placeholder : this.defaultModalTitle
      this.relatedFieldModalShow()
    },
    relatedFieldModalCancel() {
      this.relatedFieldModalHide()
    },
    relatedFieldModalApply() {
      this.relatedFieldButtonText = this.relatedFieldModalTableItemsSelected.length ? 'Изменить' : 'Выбрать'
      this.$emit('related-field-changed', this.relatedFieldModalTableItemsSelected)
      this.relatedFieldModalHide()
    },
    relatedFieldModalHide() {
      this.relatedFieldModalVisible = false
    },
    relatedFieldModalShow() {
      this.relatedFieldModalVisible = true
    },
    onRelatedFieldModalHide() {
      this.relatedFieldModalTitle = null
    },
    onRelatedFieldModalTableItemsSelected(items) {
      this.relatedFieldModalTableItemsSelected = items
    },
    getSourceFieldResourceId() {
      return this.sourceFieldModalTableItemsSelected.length ? this.sourceFieldModalTableItemsSelected[0].id : null
    },
    getRelatedFieldValue() {
      if (
        this.formData[this.fieldSetKey]
        && this.formData[this.fieldSetKey]['relatedField']
      ) {
        return this.formData[this.fieldSetKey]['relatedField'].map(item => item[this.relatedField.key]).join(', ')
      }
      return null
    },
  }
}
</script>

<style lang='scss'>

.related-field-set-wrapper {
  .row {
    margin: 0;
    &.source-field {
      margin-bottom: 1em;
    }
    .column {
      padding: 0;
      .action-button {
        margin-top: 1em;
      }
    }
  }
}

</style>
